import React, { useState, useEffect } from 'react';
import { Database, CheckCircle, AlertCircle, XCircle } from 'lucide-react';
import { apiService } from '../../services/api';

const DatabaseStatus: React.FC = () => {
  const [status, setStatus] = useState<'checking' | 'connected' | 'disconnected' | 'error'>('checking');

  useEffect(() => {
    const checkDatabase = async () => {
      try {
        // Check MongoDB connection
        const isConnected = await apiService.healthCheck();
        
        if (isConnected) {
          setStatus('connected');
        } else {
          setStatus('disconnected');
        }
      } catch (error) {
        console.error('Error verificando conexión MongoDB:', error);
        setStatus('error');
      }
    };

    // Initial check
    checkDatabase();
    
    // Set up interval for periodic checks (60 seconds)
    const interval = setInterval(checkDatabase, 60000);
    
    return () => clearInterval(interval);
  }, []);

  const getStatusColor = () => {
    switch (status) {
      case 'connected':
        return 'text-green-600';
      case 'disconnected':
        return 'text-yellow-600';
      case 'error':
        return 'text-red-600';
      default:
        return 'text-medium-gray';
    }
  };

  const getStatusIcon = () => {
    switch (status) {
      case 'connected':
        return <CheckCircle size={16} />;
      case 'disconnected':
        return <AlertCircle size={16} />;
      case 'error':
        return <XCircle size={16} />;
      default:
        return <Database size={16} className="animate-pulse" />;
    }
  };

  return (
    <div className="flex items-center space-x-2 text-sm">
      <Database size={16} className="text-medium-gray" />
      <span className={`font-medium ${getStatusColor()}`}>
        MongoDB
      </span>
      <div className={getStatusColor()}>
        {getStatusIcon()}
      </div>
    </div>
  );
};

export default DatabaseStatus;